<template>
  <div class="my-collection">
    <el-tabs v-model="activeName" type="card" @tab-click="getData">
        <el-tab-pane label="常见问题" name="knowledge_info"></el-tab-pane>
        <el-tab-pane label="补充说明" name="additional_remarks"></el-tab-pane>
    </el-tabs>
    <ul class="collection-list">
      <li v-for="item in dataList" :key="item.collectId" @mouseover="mouseOver(item)" @mouseleave="mouseLeave(item)">
        <div class="collection-list-left">
            <p v-if="activeName == 'knowledge_info'">{{item.knowledgeQuestion}}</p>
            <p v-else>{{item.content}} <br><el-link :underline="false" type="primary">{{item.implName}}</el-link></p>
            <span v-if="activeName == 'knowledge_info'">
              {{item.knowledgeAnswer}}
            </span>
        </div>
        <el-button type="primary" plain v-show="item.showBtn" size="medium" @click="dele(item)">❤ 已收藏</el-button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import api from '@/api/personApi'
export default {
    data() {
      return {
        activeName: 'knowledge_info',
        dataList:[]
      };
    },
    mounted(){
      this.getData()
    },
    computed:{
      ...mapState(["user"]),
    },
    methods: {
      // 查询
      getData(){
        let params = {
          targetObj:this.activeName,
          userId:this.user.info.id
        }
        api.myCollection(params).then(res => {
          this.dataList = res.data.list
          this.dataList.forEach(item => {
            item.showBtn = false
          });
          console.log(res,'===================我的收藏')
        }).catch(err => {
          console.log(err)
        })
      },
      mouseOver(row) {
        this.$set(row,'showBtn',true)
        this.$forceUpdate()
      },
      // 移出
      mouseLeave(row) {
        this.$set(row,'showBtn',false)
        this.$forceUpdate()
      },
      // 取消收藏
      dele(row){
        api.deleCollection({id:row.collectId}).then(res => {
          if(res.success){
            this.getData()
            this.$message.success(res.message)
          }else{
            this.$message.error(res.message)
          }
          console.log(res)
        }).catch(err => {
          console.log(err)
        })
      }
    }
}
</script>

<style lang="less" scoped>
.my-collection{
    background: #fff;
    padding: 20px;
}
.collection-list{
  width: 1000px;
  margin: 0 auto;
  li{
    list-style: none;
    padding: 24px 20px 20px;
    border-bottom: 1px solid #EBEDF0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &:hover{
      background: #F2F4F7;
    }
    .collection-list-left{
      width: 680px;
    }
    p{
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #111111;
      line-height: 18px;
      margin-bottom: 20px;
    }
    span{
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #666666;
      line-height: 24px;
    }
  }
}
</style>
